<template>
  <!-- <div v-if="$store.state.auth.status.loggedIn"> -->
    <!-- 추가된 헤더 컴포넌트 사용 -->

    <!-- {{$store.state.auth.shelterAccount}} -->
    <Header v-if="$store.state.auth.status.loggedIn"></Header>
    <div style="min-height:83vh;">
      <router-view/>
    </div>
    <!-- 추가된 풋터 컴포넌트 사용 -->
    <Footer></Footer>
  <!-- </div> -->
  <!-- <LoginView v-else/> -->
  <ConfirmDialog :breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '20vw'}"></ConfirmDialog>
  <ImagePickerModal />
  <TodoModal v-if="$store.state.auth.status.loggedIn" />
  <ScheduleFormModal v-if="$store.state.auth.status.loggedIn" />
  <VideoPickerModal />
  <!-- 쿠키 안내: 처음 접속이거나 쿠키가 막힌 브라우저면 오른쪽 아래 -->
  <CookieNotice />
  <!-- 보호소 메모 (SHELTER_MEMO) — 오른쪽 아래 '?' 버튼 위 노란 메모지 버튼(오른쪽 위 +). 누르면 메모 창 -->
  <button v-if="$store.state.auth.status.loggedIn" type="button" class="memo-fab" title="메모" @click="emitter.emit('openShelterMemo')">
    <i class="bi bi-sticky-fill memo-fab-note"></i>
    <span class="memo-fab-plus"><i class="bi bi-plus"></i></span>
  </button>
  <ShelterMemoPanel v-if="$store.state.auth.status.loggedIn" />

  <loading 
        :active="isLoading" 
        :can-cancel="true" 
        :color="'#f6951c'"
        :loader="'bars'"
        :z-index="9999"
        ></loading>
</template>

<script>

// @ is an alias to /src
// import ShelterLogin from '@/components/ShelterLogin.vue'
import Header from './components/common/Header.vue'; //import 헤더 추가
import Footer from './components/common/Footer.vue'; //import 풋터 추가
import HomeView from './views/HomeView';
import LoginView from '@/views/account/Login.vue';
import ConfirmDialog from 'primevue/confirmdialog';
import ImagePickerModal from '@/components/common/ImagePickerModal.vue';
import TodoModal from '@/components/common/TodoModal.vue';
import ScheduleFormModal from '@/components/common/ScheduleFormModal.vue';
import ShelterMemoPanel from '@/components/common/ShelterMemoPanel.vue';
import VideoPickerModal from '@/components/common/VideoPickerModal.vue';
import CookieNotice from '@/components/common/CookieNotice.vue';
// import html2canvas from 'html2canvas'

// Import the method.
import Loading from 'vue3-loading-overlay';
// Import stylesheet
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import moment from 'moment';

// import 'bootstrap/dist/js/bootstrap.esm.min.js'

// import 'bootstrap/dist/js/bootstrap';
// import 'bootstrap/dist/css/bootstrap.css'


export default {
  name: 'HomeView',

  components: {
    CookieNotice,
    Header, Footer, HomeView, LoginView, ConfirmDialog, Loading, ImagePickerModal, VideoPickerModal, TodoModal, ScheduleFormModal, ShelterMemoPanel,
  },
  data() {
    return {

      image_server : process.env.VUE_APP_IMAGE_SERVER,
      video_server : process.env.VUE_APP_VIDEO_SERVER,

      shelter : {},
      ip : "",

      isLogin : false,
      isLoading : false,

      isAdmin : false,

      //관리자 메뉴
      admin : {
        shelterList : [],
      },
    }
  },
  methods: {

    reloadAccount(){
        // if(!this.$store.state.auth.shelterAccount){
        const auth_token = JSON.parse(localStorage.getItem('auth_token'));

        if(auth_token != null && auth_token.shelterAccount){
            this.shelter = auth_token.shelterAccount;

            if(this.shelter.shelter_device_number == 'admin@pasm.kr'){
            console.log("어드민");

            this.isAdmin = true;

            this.admin.shelterList = JSON.parse(localStorage.getItem('shelter_list'));
            }else{
            this.isAdmin = false;
            }
        }else{

        }
        // console.log("local : " + this.shelter);
        // }
        // else{
        //   this.shelter = this.$store.state.auth.shelterAccount;

        //   console.log("store : " + this.shelter);
        // }


    },

    loadingStart(){
      this.isLoading = true;
    },
    loadingStop(){
      this.isLoading = false;
    },

    showToastMsg(icon, title, msg, time){
    if(time == 'default' | time == ''){
    time = 5000;
    }

    this.$toast.show(
        "<div class='row'>" +
            "<div class='col-2' style='display: grid;align-items: center;'>" +
                "<i class='bi bi-check-circle-fill' style='color : #198754; font-size: 1.4rem;'></i>" +
            "</div>" +
            "<div class='col-10' style='padding:0'>" +
                "<div class='row'><p class='mb-0' style='font-size:12px;color : #000; font-weight:600;'>"+ title +"</p></div>" +
                "<div class='row'><p class='mb-0' style='font-size:12px;color : #333;'>"+ msg +"</p></div>" +
            "</div>" +
        "</idv>",
        {
            position:"top-right",
            duration:time,
        });
    },

    modalCloseAlert(modalId){
        let result = confirm('종료하시겠습니까? 작성중이던 데이터는 저장되지 않습니다.');
        if(result){

            // console.log(modalId)
            document.getElementById(modalId).click();
        }else{

        }
    },

    insertAccessLog(type, page_name, processing_information, download_reason){
      let me = this;
      let log = {};

      log.shelter = this.shelter.shelter_device_number;
      log.type = type;
      log.page_name = page_name;
      log.download_reason = download_reason;
      log.processing_information = processing_information;

      // console.log(log.ip);

      let config = {
          "headers": {
              "Content-Type": "multipart/form-data",
          }
      };

      const formData = new FormData();

      formData.append("pasmAccessLog", this.$common.convertFormData(log));

      this.axios.post('/log', formData, config)
          .then(function (res) {

          }).catch(function (error) {
              me.$root.loadingStop();

              console.log(error);
              alert('등록 에러');
      });
    }

  },
  mounted(){
  },
  created (){
    if(!this.$store.state.auth.status.loggedIn){
      this.$router.push('/login');
    }

    this.reloadAccount();
  },
  computed(){

  }
  
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
  }
}

.c-toast{
    color : #333 !important;
    padding: 0.5em 1rem !important;
    background-color: #ffffff !important;
    border : 1px solid #a9a9a9;
    box-shadow: 1px 1px 1px #ededed;
    min-width: 20%;
    min-height: 4em !important;
}
.p-dialog .p-dialog-footer {
  border-top : 0 !important;
}

.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.5) !important;
}

/* 보호소 메모 버튼: '?' 가이드 버튼(.floating-button-layer, 54px · 아래 5rem)과 같은 줄, 바로 위 */
.memo-fab {
  /* 창(모달, z 1000) 위에도 떠 있어야 동물·신청서 상세를 보면서 메모 가능 */
  position: fixed; right: 5rem; bottom: calc(5rem + 54px + 12px); z-index: 1035;
  width: 54px; height: 54px; border-radius: 50%; border: none; padding: 0;
  background: #FFD54F; color: #7a5a00;
  display: inline-flex; align-items: center; justify-content: center;
  box-shadow: 0 3px 10px rgba(224, 168, 0, 0.45); cursor: pointer;
  transition: transform .15s, background .15s, box-shadow .15s;
}
.memo-fab .memo-fab-note { font-size: 25px; line-height: 1; color: #fff; filter: drop-shadow(0 1px 0 rgba(160, 110, 0, 0.35)); }
/* 메모지 오른쪽 위 + */
.memo-fab .memo-fab-plus {
  position: absolute; top: 9px; right: 9px; width: 18px; height: 18px; border-radius: 50%;
  background: #f6951c; color: #fff; border: 2px solid #FFD54F;
  display: inline-flex; align-items: center; justify-content: center;
}
.memo-fab .memo-fab-plus i { font-size: 15px; line-height: 1; -webkit-text-stroke: 0.6px #fff; }
.memo-fab:hover { background: #FFCA28; transform: translateY(-2px); box-shadow: 0 6px 16px rgba(224, 168, 0, 0.5); }
.memo-fab:hover .memo-fab-plus { border-color: #FFCA28; }
@media (max-width: 768px) {
  .memo-fab { right: 1.2rem; bottom: calc(1.2rem + 36px + 10px); width: 40px; height: 40px; }
  .memo-fab .memo-fab-note { font-size: 19px; }
  .memo-fab .memo-fab-plus { top: 5px; right: 5px; width: 15px; height: 15px; }
  .memo-fab .memo-fab-plus i { font-size: 12px; }
  body.modal-open .memo-fab, body.modal-open .smp,
  body:has(.modal-area:not([style*="display: none"])) .memo-fab, body:has(.modal-area:not([style*="display: none"])) .smp,
  body:has(.p-dialog-mask) .memo-fab, body:has(.p-dialog-mask) .smp,
  body:has(.hc-pop) .memo-fab, body:has(.hc-pop) .smp { display: none !important; }
}

/* 모바일: 오른쪽 아래 '?' 가이드 버튼(.floating-button-layer, 각 화면에 있음)이 창(모달)의 아래 고정 버튼을 가리지 않게
   창이 떠 있는 동안 숨김 — 직접 만든 창(.modal-area), 부트스트랩 창(body.modal-open), primevue 확인창, 홈 캘린더 시트 */
@media (max-width: 768px) {
  body.modal-open .floating-button-layer,
  body:has(.modal-area:not([style*="display: none"])) .floating-button-layer,
  body:has(.p-dialog-mask) .floating-button-layer,
  body:has(.hc-pop) .floating-button-layer {
    display: none !important;
  }
}
</style>
